/* Polyfills */
import "core-js/stable";
import "regenerator-runtime/runtime";

/* Modules */
import Nav from './modules/Nav';
import CookieBanner from './modules/CookieBanner'
import Listing from './modules/Listing'
import PickUpButtons from './modules/PickUpButtons'
import AlertBanner from './modules/AlertBanner'
import LanguageSelector from './modules/LanguageSelector'
import DataLayer from './modules/DataLayer'
import OutboundLinks from './modules/OutboundLinks'
import FooterSignup from './modules/FooterSignup'
import GForms from './modules/GForms'
import SubNav from './modules/SubNav'
import VideoHero from './modules/VideoHero'
import SearchAnimation from './modules/SearchAnimation'
import GlobalAnimations from './modules/GlobalAnimations'

/* Packages */
import EventBus from "simple-event-bus/EventBus";

let alertBanner = null;

document.addEventListener("DOMContentLoaded", () => {
  new Nav();
  new PickUpButtons();
  window.event_bus = new EventBus();

  const footerEmailContainer = document.querySelector('.footer__newsletter-cta-container');
  if (footerEmailContainer) {
    new FooterSignup(footerEmailContainer);
  }

  const gform = document.querySelector('.gform_wrapper');
  if (gform != null) {
    new GForms(gform)
  }

  const subNavElement = document.querySelector('.js-subnav');
  if (subNavElement != null) {
    new SubNav(subNavElement);
  }

  const youTubeVideoHero = document.querySelector('.js-yt-video-play-hero');
    if(youTubeVideoHero != null) {
      new VideoHero(youTubeVideoHero);
    }

  const searchAnimation = document.querySelector('.js-search-modal');
  if(searchAnimation != null) {
    new SearchAnimation(searchAnimation);
  }

  new GlobalAnimations();
});

window.addEventListener('load', (event) => {

  const cookieBannerElement = document.querySelector('.js-cookie-banner');
  if (cookieBannerElement != null) {
    var cookieBanner = new CookieBanner();
  }

  const alertBannerElement = document.querySelector('.js-alert-banner');
  if (alertBannerElement != null) {
    var alertBanner = new AlertBanner();
  }

  const listingContainerElement = document.querySelector('.js-listing-container');
  if (listingContainerElement != null) {
    var listingPage = new Listing();
  }

  const languageFormElement = document.querySelector('.js-lang-select');
  if (languageFormElement != null) {
    var languageForm = new LanguageSelector();
  }

  const header = document.querySelector('header');
  if (header != null) {
    var dataLayer = new DataLayer();
  }

  new OutboundLinks();
});

window.addEventListener('resize', (event) => {
  if (alertBanner != null && (!alertBanner.hasClosed() || alertBanner.hasChanged())) {
    alertBanner.resizeBanner();
  }
});
